import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { bindActionCreators } from "redux";
import {
  renderFieldText,
  renderSelect,
  classNames,
  renderDatePickerWithLabel,
} from "@basecomponent";
import LocaleStrings from "@language";
import ItemList from "./item-list";
import {
  fetchPurchaseTransaction,
  emptyTransaction,
  fetchConversionRate,
} from "@transactionaction";
import {
  fetchSpecification,
  fetchVehicleList,
  fetchLocation,
  fetchService,
} from "@numberplateaction";
import { fetchBagdeList } from "@badgesaction";
import { fetchMyProfile } from "@personalinfoaction";
import Loader from "@loader";
import _ from "lodash";
import moment from "moment";
import { DATE_FORMAT } from "@constant";
const Transaction = (props) => {
  var {
    handleSubmit,
    pristine,
    invalid,
    submitting,
    session,
    transactionList,
    specList,
    vehicleList,
    badgeList,
    locationList,
    eventData,
    serviceList,
    localeLanguage,
    myProfile,
  } = props;
  var [loading, setLoading] = useState(false);

  const paymodeArr = [
    { key: "ideal", name: "Ideal" },
    { key: "bancontact", name: "Bancontact" },
    { key: "kbc", name: "KBC" },
    { key: "mastercard", name: "Mastercard" },
    { key: "maestro", name: "Maestro" },
    { key: "visa", name: "Visa" },
    { key: "cash", name: "Cash" },
  ];

  const tabsArr = [
    { key: "bought", name: LocaleStrings.bought, href: "#", current: true },
    { key: "spent", name: LocaleStrings.spent, href: "#", current: false },
  ];
  const [currentTab, setCurrentTab] = useState("bought");
  const [tabs, setTabs] = useState(tabsArr);
  const [searchParams, setSearchParams] = useState({
    amount: 0,
    startdate: "",
    enddate: "",
  });

  useEffect(() => {
    //var userLang = LocaleStrings.getLanguage();
    if (localeLanguage) {
      let tabsArr = [
        {
          key: "bought",
          name: LocaleStrings.bought,
          href: "#",
          current: true,
        },
        {
          key: "spent",
          name: LocaleStrings.spent,
          href: "#",
          current: false,
        },
      ];
      setTabs(tabsArr);
    }
  }, [localeLanguage]);
  useEffect(() => {
    props.fetchService(session);
    if (eventData) {
      props.fetchVehicleList(session, eventData.useridfk, 0, (res) => {});
      props.fetchBagdeList(session, eventData.useridfk, 0, (res) => {});
      props.fetchLocation(session, eventData.useridfk);
      props.fetchSpecification(session, eventData.useridfk, (res) => {});
      props.fetchConversionRate(props.session, eventData.useridfk);
      let pobj = {};
      pobj.companyid = eventData.useridfk;
      props.fetchPurchaseTransaction(session, pobj);
    }
    props.fetchMyProfile(session);
  }, [eventData]);

  const handleTabs = (tab) => {
    props.reset();
    props.emptyTransaction();
    let type = tab.key == "spent" ? "redeem" : "purchase";
    let pobj = {};
    pobj.startdate = "";
    pobj.enddate = "";
    pobj.companyid = eventData.useridfk;
    props.fetchPurchaseTransaction(props.session, pobj, type);
    tabs.map((obj) => {
      if (obj.key === tab.key) {
        obj.current = true;
      } else {
        obj.current = false;
      }
    });

    setCurrentTab(tab.key);
    setTabs([...tabs]);
  };

  const onSubmitForm = (values) => {};

  const renderItems = () => {
    //console.log("transactionList", transactionList);
    return transactionList?.data?.map((item, index) => {
      return (
        <ItemList
          key={`key_${index}`}
          listitem={item}
          currentTab={currentTab}
        />
      );
    });
  };

  const searchList = (field, value) => {
    //console.log("field", field);
    //console.log("value", value);
    let filterData = {};
    let values = {};
    if (value == "startdate") {
      let startdate = moment(field).format(DATE_FORMAT);
      filterData.startdate = startdate;
      values.startdate = startdate;
      if (searchParams.enddate) {
        filterData.enddate = searchParams.enddate;
      }
    } else if (value == "enddate") {
      let enddate = moment(field).format(DATE_FORMAT);
      filterData.enddate = enddate;
      values.enddate = enddate;
      if (searchParams.startdate) {
        filterData.startdate = searchParams.startdate;
      }
    } else {
      for (const [key, value] of Object.entries(searchParams)) {
        filterData[key] = value;
      }
      filterData[field] = value;
      values[field] = value;
    }
    props.emptyTransaction();
    updateValues(values);
    let type = currentTab == "spent" ? "redeem" : "purchase";
    filterData.companyid = eventData.useridfk;
    props.fetchPurchaseTransaction(props.session, filterData, type);
  };

  const updateValues = (newelement) => {
    setSearchParams((prevState) => {
      return { ...prevState, ...newelement };
    });
  };

  let specoptions = [];
  if (paymodeArr.length > 0) {
    _.map(paymodeArr, (item, index) => {
      specoptions.push({ value: item.key, text: item.name });
    });
  }

  let numberplateOption = [];
  let referenceOption = [];
  if (vehicleList?.data?.length > 0) {
    _.map(vehicleList.data, (item, index) => {
      numberplateOption.push({
        value: item.numberplate,
        text: item.numberplate,
      });
      var match = _.filter(referenceOption, (ob) => {
        return ob.value == item.reference;
      });

      if (match.length === 0) {
        referenceOption.push({
          value: item.reference,
          text: item.reference,
        });
      }
    });
  }

  let badgeOption = [];
  if (badgeList?.data?.length > 0) {
    _.map(badgeList.data, (item, index) => {
      badgeOption.push({
        value: item.numberplate,
        text: item.numberplate,
      });
      var match = _.filter(referenceOption, (ob) => {
        return ob.value == item.reference;
      });

      if (match.length === 0 && item.reference != "") {
        referenceOption.push({
          value: item.reference,
          text: item.reference,
        });
      }
    });
  }

  let locationOption = [];
  if (locationList?.data?.length > 0) {
    _.map(locationList.data, (item, index) => {
      locationOption.push({
        value: item.locationid,
        text: item.stationname,
      });
    });
  }

  let serviceOption = [];
  if (serviceList?.data?.length > 0) {
    _.map(serviceList.data, (item, index) => {
      serviceOption.push({
        value: item.id,
        text: item.servicename,
      });
    });
  }

  return (
    <>
      <div className="p-8 space-y-10">
        <div className="bg-white rounded-lg w-full p-6 text-base shadow-md h-90%">
          <div className="pb-2 mb-4">{LocaleStrings.my_transaction}</div>
          <div>
            <nav className="flex justify-center space-x-4" aria-label="Tabs">
              {tabs.map((item) => (
                <a
                  key={item.name}
                  onClick={() => handleTabs(item)}
                  className={classNames(
                    item.current
                      ? "manage_bg text-white"
                      : "bg-chargecredit text-bluetext cursor-pointer",
                    "px-6 md:px-12 py-2 font-medium text-sm rounded-md"
                  )}
                  aria-current={item.current ? "page" : undefined}
                >
                  {item.name}
                </a>
              ))}
            </nav>

            <div className="mt-7">
              {currentTab == "bought" ? (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
                  <Field
                    name="amount"
                    label=""
                    placeholder={LocaleStrings.search_by_amount}
                    type="text"
                    component={renderFieldText}
                    mandatory="true"
                    maxlength={100}
                    onChange={(e) => searchList("amount", e.target.value)}
                  />
                  <Field
                    name="payment_method"
                    label=""
                    placeholder={LocaleStrings.search_by_payment}
                    component={renderSelect}
                    mandatory="true"
                    opts={specoptions}
                    onChange={(e) => searchList("paymode", e.target.value)}
                  />

                  <Field
                    name="from_date"
                    label=""
                    placeholder={LocaleStrings.search_by_from_date}
                    type="text"
                    component={renderDatePickerWithLabel}
                    mandatory="true"
                    onChange={(e) => searchList(e, "startdate")}
                  />
                  <Field
                    name="till_date"
                    label=""
                    placeholder={LocaleStrings.search_by_till_date}
                    type="text"
                    component={renderDatePickerWithLabel}
                    mandatory="true"
                    onChange={(e) => searchList(e, "enddate")}
                  />
                </div>
              ) : (
                <>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                    <Field
                      name="serviceid"
                      label=""
                      placeholder={LocaleStrings.search_by_service}
                      component={renderSelect}
                      mandatory="true"
                      opts={serviceOption}
                      onChange={(e) => searchList("service", e.target.value)}
                    />

                    <Field
                      name="numberplate"
                      label=""
                      placeholder={LocaleStrings.search_by_numberplate}
                      type="text"
                      component={renderFieldText}
                      mandatory="true"
                      onChange={(e) =>
                        searchList("numberplate", e.target.value)
                      }
                    />

                    <Field
                      name="badge"
                      label=""
                      placeholder={LocaleStrings.search_by_badge}
                      type="text"
                      component={renderFieldText}
                      mandatory="true"
                      onChange={(e) => searchList("badge", e.target.value)}
                    />
                  </div>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
                    <Field
                      name="locationid"
                      label=""
                      placeholder={LocaleStrings.search_by_location}
                      component={renderSelect}
                      mandatory="true"
                      opts={locationOption}
                      onChange={(e) => searchList("location", e.target.value)}
                    />
                    <Field
                      name="reference"
                      label=""
                      placeholder={LocaleStrings.search_by_reference}
                      type="text"
                      component={renderFieldText}
                      mandatory="true"
                      onChange={(e) => searchList("reference", e.target.value)}
                    />

                    <Field
                      name="sfrom_date"
                      label=""
                      placeholder={LocaleStrings.search_by_from_date}
                      type="text"
                      component={renderDatePickerWithLabel}
                      mandatory="true"
                      onChange={(e) => searchList(e, "startdate")}
                    />
                    <Field
                      name="still_date"
                      label=""
                      placeholder={LocaleStrings.search_by_till_date}
                      type="text"
                      component={renderDatePickerWithLabel}
                      mandatory="true"
                      onChange={(e) => searchList(e, "enddate")}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="overflow-x-auto">
            <div className="align-middle inline-block min-w-full">
              {transactionList?.data ? (
                <div className=" ">
                  <table className="min-w-full divide-y divide-gray-200 mt-5">
                    <thead className="bg-gray-50">
                      <tr>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          {LocaleStrings.date_header}
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          {LocaleStrings.amount_header}
                        </th>
                        {currentTab == "bought" ? (
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            {LocaleStrings.paid_header}
                          </th>
                        ) : (
                          ""
                        )}
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          {currentTab == "bought"
                            ? LocaleStrings.free_header
                            : LocaleStrings.tr_service_header}
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          {currentTab == "bought"
                            ? LocaleStrings.payment_header
                            : LocaleStrings.tr_numberplate_header}
                        </th>
                        <th
                          scope="col"
                          className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                        >
                          {currentTab == "bought"
                            ? LocaleStrings.validity_header
                            : LocaleStrings.tr_reference_header}
                        </th>
                        {currentTab == "bought" ? (
                          <th
                            scope="col"
                            className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                          >
                            {myProfile && myProfile.iscompanyhr == 1
                              ? LocaleStrings.invoice_header
                              : LocaleStrings.ticket_header}
                          </th>
                        ) : (
                          ""
                        )}
                      </tr>
                    </thead>
                    <tbody>{renderItems()}</tbody>
                  </table>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const validate = (values) => {};

const mapStateToProps = (state) => {
  var init = {};
  return {
    session: state.session,
    initialValues: init,
    transactionList: state.transactionList,
    vehicleList: state.vehicleList,
    badgeList: state.badgeList,
    locationList: state.locationList,
    eventData: state.eventData,
    serviceList: state.serviceList,
    localeLanguage: state.localeLanguage,
    myProfile: state.myProfile.data,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchPurchaseTransaction,
      fetchSpecification,
      fetchBagdeList,
      fetchVehicleList,
      fetchLocation,
      fetchService,
      emptyTransaction,
      fetchMyProfile,
      fetchConversionRate,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: "TransactionForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(Transaction)
);
